import {
  DynamicZoneComponentDTO,
  StrapiDynamicZoneComponentDTO,
} from "@lib/strapi/dtos/core/dynamicZoneComponent.dto";
import {
  StrapiGoogleReviewsSectionDTO,
  GoogleReviewsSectionDTO,
} from "@lib/strapi/dtos/components/sections/googleReviewsSection.dto";

export class GoogleReviewsSectionService {
  static async fromStrapi(
    locale: string,
    strapiData?: StrapiGoogleReviewsSectionDTO,
  ): Promise<GoogleReviewsSectionDTO> {
    if (!strapiData) {
      return null;
    }
    const dto = new GoogleReviewsSectionDTO();
    Object.assign(
      dto,
      await DynamicZoneComponentDTO.fromStrapi(locale, strapiData),
    );
    dto.heading = strapiData.heading;
    dto.layout = strapiData.layout;
    dto.maxItems = strapiData.maxItems;
    dto.showAggregate = strapiData.showAggregate;
    dto.writeReviewCta = strapiData.writeReviewCta;
    dto.profileLink = strapiData.profileLink;
    return dto;
  }
}
